import { useEffect } from "react";
import { Outlet, useLocation } from "react-router-dom";
import { useLenis } from "@/hooks/useLenis";
import { Nav } from "@/components/site/Nav";
import { Footer } from "@/components/site/Footer";
import { FloatingWhatsApp } from "@/components/site/FloatingWhatsApp";

export const Layout = () => {
  useLenis();
  const { pathname } = useLocation();

  useEffect(() => {
    const id = setTimeout(() => {
      if (window.__lenis) window.__lenis.scrollTo(0, { immediate: true });
      else window.scrollTo(0, 0);
    }, 0);
    return () => clearTimeout(id);
  }, [pathname]);

  return (
    <div className="App min-h-screen bg-bg">
      <Nav />
      <main>
        <Outlet />
      </main>
      <Footer />
      <FloatingWhatsApp />
    </div>
  );
};
